import { render, staticRenderFns } from "./c-empty.vue?vue&type=template&id=4c0306a4&scoped=true"
import script from "./c-empty.vue?vue&type=script&setup=true&lang=js"
export * from "./c-empty.vue?vue&type=script&setup=true&lang=js"
import style0 from "./c-empty.vue?vue&type=style&index=0&id=4c0306a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0306a4",
  null
  
)

export default component.exports